import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {map, Observable, zip} from 'rxjs';
import {CommonBlobStorageService} from '../../shared/services/blob-storage/common-blob-storage.service';
import {SpinnerOverlayService} from '../../shared/services/spinner-overlay/spinner-overlay.service';
import {IndustrySegmentService} from '../../shared/services/industry-segment/industry-segment.service';

@Injectable({
  providedIn: 'root',
})
export class CustomersGuard {
  private qmsBlobStorageService = inject(CommonBlobStorageService);
  private spinner = inject(SpinnerOverlayService);
  private industrySegmentService = inject(IndustrySegmentService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.spinner.performWithSpinner(zip(
      this.qmsBlobStorageService.loadBlobStorageConfiguration(),
      this.industrySegmentService.loadIndustrySegment(false)
    ).pipe(map(() => {
      return true;
    })));
  }
}
